import { connect } from 'react-redux';
import {
  setBookingValue,
  setBookingValidity,
  fetchBookingPrice,
} from '../../../features/processing/actions';
import BookingForm from '../components/BookingForm';

const mapStateToProps = (state, props) => props;

const mapDispatchToProps = (dispatch) => ({
  onDropdownChange: (option, index, e) => {
    dispatch(setBookingValue(e.target.id, option.value));
  },
  onTextChange: (e) => {
    dispatch(setBookingValue(e.target.id, e.target.value));
  },
  onCheckboxChange: (e) => {
    const id = e.target.id;
    dispatch(setBookingValue(id, e.target.checked));
    if (/terms_of_service|insurance_terms_of_service/.test(id)) {
      dispatch(setBookingValidity(id, e.target.checked));
    }
  },
  onPaymentChange: (option) => {
    dispatch(setBookingValue('payment_method', option.value));
    dispatch(fetchBookingPrice(option.value));
  },
  onValidate: (hasError, value, field) => {
    dispatch(setBookingValidity(field.id, !hasError));
  },
});

const BookingFormContainer = connect(mapStateToProps, mapDispatchToProps)(BookingForm);

BookingFormContainer.propTypes = BookingForm.propTypes;

export default BookingFormContainer;
